import {
  CContainer,
  CModal,
  CModalBody,
  CModalHeader,
  CModalTitle,
} from "@coreui/react";
import { useEffect, useState } from "react";
import Errors from "../../models/errors";
import RecordPdfForm from "./RecordPdfForm";
import GeneratedRecord, {
  newGeneratedRecord,
} from "../../models/generated-record";

interface RecordUpdateModalProps {
  show: boolean;
  record?: GeneratedRecord;
  onCancel: () => void | Promise<void>;
  onSuccess: () => void | Promise<void>;
}

const RecordUpdateModal: React.FC<RecordUpdateModalProps> = ({
  show,
  record,
  onCancel,
  onSuccess,
}) => {
  const [initialErrors, setInitialErrors] = useState<Errors>({});
  const [initialRecord, setInitialRecord] = useState<GeneratedRecord>(
    record ? record : newGeneratedRecord()
  );

  const modalTitle = record
    ? `Agregar PDF a Entrada: #${record.id}`
    : `Agregar PDF a Entrada`;

  const onClose = () => {
    setInitialErrors({});
    setInitialRecord(newGeneratedRecord());
    onCancel();
  };
  useEffect(() => {
    setInitialRecord(record ? record : newGeneratedRecord());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [record]);

  return (
    <CModal show={show} onClose={onClose} size="xl">
      <CModalHeader closeButton>
        <CModalTitle>{modalTitle}</CModalTitle>
      </CModalHeader>
      <CModalBody>
        <CContainer fluid>
          <RecordPdfForm
            initialRecord={initialRecord}
            initialErrors={initialErrors}
            onCancel={onCancel}
            onSuccess={onSuccess}
          />
        </CContainer>
      </CModalBody>
    </CModal>
  );
};

export default RecordUpdateModal;
